import { CircularProgress, Stack, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { AccountTierTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";
import DeleteIcon from '@mui/icons-material/Delete';
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const AccountTierTable: React.FC<AccountTierTablePropsType> = ({ rows, handleItemClick, selectedTierId }) => {
    const accountTierTableHeaders = ["Country", "Tier", "Daily Limit", "Action"];

    return (
        <BaseTable headers={accountTierTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.country}</TableCell>
                            <TableCell>{row?.name}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.dailyLimit ?? 0)}</TableCell>
                            <TableCell>
                                <Stack direction="row" gap="calc(var(--flex-gap)/4)">
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick(e, row.id, "edit")}
                                    >
                                        Edit
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick?.(e, { tierId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {selectedTierId !== null && selectedTierId === row.id ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
